import * as React from "react";

import { TextContainer as Text } from "../Text/TextContainer";
import { FocusManagementObserver } from "../../Services/FocusManagement/FocusManagementObserver";
import {
    AbsoluteModelPath,
    createRelativeResolvedModelPath,
    RelativeResolvedModelPath,
} from "../../../../../Common/ModelPath/ModelPath";
import { emptyRef } from "../../TypingUtils";

import { Root } from "./FIO.styles";

export interface FIOProps {
    pathPrefix: AbsoluteModelPath;
    quotes?: [string, string];
    showError?: boolean;
    error: string | undefined;
    style: React.CSSProperties;
    isReadOnly?: boolean;
}

export const nameSuffix: RelativeResolvedModelPath = createRelativeResolvedModelPath("Имя");
export const surnameSuffix: RelativeResolvedModelPath = createRelativeResolvedModelPath("Фамилия");
export const patronymicSuffix: RelativeResolvedModelPath = createRelativeResolvedModelPath("Отчество");

export function FIO(props: FIOProps): JSX.Element {
    const container = React.useRef<HTMLDivElement>(emptyRef);

    return (
        <FocusManagementObserver onRequestFocus={() => container.current?.focus()}>
            <Root error={props.error != undefined} ref={container} tabIndex={-1} style={props.style}>
                {props.error != undefined
                    ? renderError(props.error, props.isReadOnly ? false : (props.showError ?? true))
                    : renderContent(props.pathPrefix, props.quotes ?? ["", ""])}
            </Root>
        </FocusManagementObserver>
    );
}

const renderError = (error: string, showError: boolean) => <>{showError ? error : ""}</>;

const renderContent = (pathPrefix: AbsoluteModelPath, quotes: [string, string]) => (
    <>
        {quotes[0] ?? ""}
        <Text data-tid="surname" bindingPath={pathPrefix.joinWith(surnameSuffix)} />{" "}
        <Text data-tid="name" bindingPath={pathPrefix.joinWith(nameSuffix)} />{" "}
        <Text data-tid="patronymic" bindingPath={pathPrefix.joinWith(patronymicSuffix)} />
        {quotes[1] ?? ""}
    </>
);
